import axios from 'axios';

const UserHerramienta = process.env.REACT_APP_NAMEAPP;
const baseURLUsuario = process.env.REACT_APP_API_USUARIO

const baseURL = baseURLUsuario + '/api/usuario';
const apiUserURL = baseURLUsuario+'/api/url';

async function login({ username, password }) {
    const { data } = await axios.post(`${baseURL}/login`,
        { user: username, password: password, herramienta: UserHerramienta },
        {
            withCredentials: true,
            headers: {
                'access-control-allow-origin': '*',
                'access-control-allow-credentials': 'true',
                'content-type': 'application/json'
            }
        });

    return data;
};

async function isLogged() {
    const { data } = await axios.post(`${baseURL}/islogged`,
        { herramienta: UserHerramienta },
        {
            withCredentials: true,
            headers: {
                'access-control-allow-origin': '*',
                'access-control-allow-credentials': 'true',
                'content-type': 'application/json'
            }
        });
    return data;
};

async function logout() {
    const { data } = await axios.post(`${baseURL}/logout`,
        {},
        {
            withCredentials: true,
            headers: {
                'access-control-allow-origin': '*',
                'access-control-allow-credentials': 'true',
                'content-type': 'application/json'
            }
        });
    return data;
};

async function getURLs() {
    const { data } = await axios.get(`${apiUserURL}`,
        {},
        {
            withCredentials: true,
            headers: {
                'access-control-allow-origin': '*',
                'access-control-allow-credentials': 'true',
                'content-type': 'application/json'
            }
        });
    return data;
}

export default { login, logout, isLogged, getURLs };

